import { render, staticRenderFns } from "./BaseInputSwitch.vue?vue&type=template&id=679048e6&scoped=true&"
import script from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSwitch.vue?vue&type=style&index=0&id=679048e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679048e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679048e6')) {
      api.createRecord('679048e6', component.options)
    } else {
      api.reload('679048e6', component.options)
    }
    module.hot.accept("./BaseInputSwitch.vue?vue&type=template&id=679048e6&scoped=true&", function () {
      api.rerender('679048e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputSwitch.vue"
export default component.exports